// HeightDifferenceCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Selisih Tinggi Badan Antara Dua Orang";
const DESCRIPTION =
  "Hitung selisih tinggi badan antara dua orang menggunakan kalkulator sederhana ini. Alat ini membantu Anda mengetahui perbedaan pasti dalam tinggi badan antara dua orang saat memasukkan tinggi badan mereka.";
const KEYWORDS = "kalkulator, selisih tinggi badan, dua orang, perbandingan, tinggi, tinggi badan";
const OG_URL =
  "https://do-calculate.com/calculator/id/height-difference-calculator/";
function HeightDifferenceCalculator() {
  const [heightPerson1, setHeightPerson1] = useState("0");
  const [heightPerson2, setHeightPerson2] = useState("0");
  const [heightDifference, setHeightDifference] = useState(null);
  const [error, setError] = useState("");
  const calculateHeightDifference = () => {
    try {
      if (heightPerson1 === "0" && heightPerson2 === "0") {
        setError("Silakan masukkan tinggi badan yang valid untuk menghitung selisihnya");
        return;
      }
      const difference = Math.abs(heightPerson1 - heightPerson2);
      setHeightDifference(difference);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara sederhana untuk mengetahui selisih tinggi badan antara dua orang.
                  Baik Anda ingin membandingkan tinggi badan Anda dengan teman atau anggota keluarga, alat
                  ini dapat membantu Anda mendapatkan jawaban dengan cepat dan mudah. Selisih tinggi badan
                  didasarkan pada memasukkan tinggi badan kedua orang yang ingin Anda bandingkan.
                  Alat ini berguna dalam berbagai skenario, seperti membandingkan tinggi badan anak-anak dengan orang tua
                  atau hanya karena rasa ingin tahu.
                </p>
                <p>
                  Misalnya, jika Anda ingin mengetahui selisih tinggi badan antara seseorang dengan tinggi 180 cm
                  dan orang lain dengan tinggi 170 cm, Anda dapat menggunakan kalkulator ini untuk menentukan
                  selisihnya secara akurat. Selisih dihitung dengan sederhana dengan mengurangkan tinggi yang lebih kecil
                  dari tinggi yang lebih besar. Informasi ini mungkin berguna saat memilih pakaian
                  atau saat membeli sepatu dengan hak tinggi, di mana perbedaan tinggi badan dapat mempengaruhi pilihan Anda.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="1st-Input">Tinggi badan orang pertama:</label>
                    <input
                      id="1st-Input"
                      type="number"
                      value={heightPerson1}
                      onChange={(e) => setHeightPerson1(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text ">cm</span>
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="2nd-Input">Tinggi badan orang kedua:</label>
                    <input
                      id="2nd-Input"
                      type="number"
                      value={heightPerson2}
                      onChange={(e) => setHeightPerson2(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text ">cm</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateHeightDifference}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  heightDifference !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Selisih tinggi badan: {heightDifference.toFixed(2)} cm</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Cara Menghitung Selisih Tinggi Badan Antara Dua Orang
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 1: Tentukan Tinggi Badan Orang Pertama
                    </h2>
                  </u>
                  <p>
                    Pertama, Anda perlu mengetahui tinggi badan orang pertama yang ingin Anda hitung
                    selisihnya. Tinggi badan harus diukur dalam sentimeter (cm) untuk memudahkan perhitungan.
                    Orang ini bisa jadi Anda sendiri atau orang lain yang ingin Anda bandingkan tinggi badannya
                    dengan orang lain. Pastikan untuk mengukur tinggi badan dengan akurat, karena nilai yang benar
                    akan membantu Anda mendapatkan hasil yang akurat dan dapat diandalkan.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 2: Tentukan Tinggi Badan Orang Kedua
                    </h2>
                  </u>
                  <p>
                    Setelah menentukan tinggi badan orang pertama, langkah berikutnya adalah mengetahui tinggi badan
                    orang kedua. Sekali lagi, pastikan tinggi badan diukur dalam sentimeter (cm).
                    Orang kedua bisa jadi teman, anggota keluarga, atau bahkan selebritas yang ingin Anda ketahui
                    selisih tinggi badannya dengan Anda. Memasukkan tinggi badan dengan akurat akan membantu mendapatkan
                    perhitungan yang tepat untuk selisih tinggi badan.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 3: Hitung Selisih Tinggi Badan
                    </h2>
                  </u>
                  <p>
                    Setelah memasukkan tinggi badan kedua orang, Anda dapat dengan mudah menghitung selisih
                    di antara mereka. Untuk menghitung selisih tinggi badan, yang perlu Anda lakukan adalah
                    mengurangkan tinggi yang lebih kecil dari tinggi yang lebih besar. Proses perhitungan sederhana
                    ini akan memberi Anda selisih tepat dalam tinggi badan antara kedua orang.
                    Jika hasilnya nol, ini berarti kedua orang memiliki tinggi yang sama.
                    Jika hasilnya positif atau negatif, Anda akan tahu siapa yang lebih tinggi.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika tinggi orang pertama 180 cm dan tinggi orang kedua 170 cm, maka selisih tinggi badan adalah 10 cm.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Gunakan Selisih Tinggi Badan dalam Kehidupan Sehari-hari
                    </h2>
                  </u>
                  <p>
                    Setelah menghitung selisih tinggi badan, informasi ini dapat memiliki berbagai aplikasi
                    dalam kehidupan sehari-hari. Misalnya, saat membeli pakaian, selisih tinggi badan antara dua orang
                    dapat menjadi indikator yang baik untuk memilih ukuran yang tepat. Ini juga dapat membantu Anda
                    dalam merencanakan acara yang memerlukan pengaturan orang berdasarkan tinggi badan, seperti
                    foto bersama atau acara formal. Memahami selisih tinggi badan juga dapat membantu Anda
                    dalam interaksi sosial, karena Anda dapat menggunakan informasi ini dalam percakapan sehari-hari.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika Anda dan seorang teman berencana membeli jenis pakaian yang sama, selisih tinggi badan dapat membantu Anda memilih ukuran yang tepat.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default HeightDifferenceCalculator;